import ProxyServerConnector from '~/services/connectors/ProxyServerConnector';
import FigmaFile from 'packages/pages/designCreateModal/pages/figma/FigmaFile';

class FigmaService extends ProxyServerConnector {
    constructor(path = '/figma') {
         
        super(path, GATEWAY_PREFIX);
    }

    getConnectionStatus() {
        return this.get<
            | { connected: false; message: string }
            | { connected: true; figmaUserId: string; email: string; created: string }
        >('/auth/connection-status');
    }

    /**
     * @param location - The location to redirect to after login
     */
    getLoginUrl(location: string) {
        return this.get<{ url: string }>(`/auth/login-url?location=${encodeURIComponent(location)}`);
    }

    revokeAccess() {
        return this.delete('/auth/revoke-access');
    }

    getFile(fileKey: string) {
        return this.get<typeof FigmaFile | { status: string }>(`/files/${fileKey}`, {}, {}, false);
    }
}

export default new FigmaService();
